import { isSupportedMedal } from '../../../../types/medalTypes';
import { parseInboundPayload } from '../../inbound';
import { createArrayWithBracesParser, encodedStringParser, numberOrUndefinedParser, numberParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
export function playerMedalsParser(str) {
    return createArrayWithBracesParser(playerMedalParser, true)(str);
}
/**
 * Parse a medal string into a typed PlayerMedal object, returning undefined if the label is unrecognized/unsupported.
 */
function playerMedalParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    const { label, ...rest } = parseInboundPayload(inboundParts, inboundPlayerMedalPartDefinitions);
    if (!isSupportedMedal(label)) {
        return;
    }
    return { type: label, ...rest };
}
const inboundPlayerMedalPartDefinitions = [
    { name: 'label', parser: encodedStringParser },
    { name: 'name', parser: encodedStringParser },
    { name: 'rank', parser: numberOrUndefinedParser },
    { name: 'value', parser: numberOrUndefinedParser },
    { name: 'quantity', parser: numberParser }
];
